import { render } from "./Character.vue?vue&type=template&id=6b204432"
import script from "./Character.vue?vue&type=script&lang=js"
export * from "./Character.vue?vue&type=script&lang=js"

import "./Character.vue?vue&type=style&index=0&id=6b204432&lang=css"

import exportComponent from "C:\\Users\\PC\\Documents\\vue.js\\marvel\\marvel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__